import type { ActionHandler } from '../types';
import { invokeSemanticPort, readString } from './helpers';

export const selectVariantHandler: ActionHandler = {
  type: 'select_variant',
  execute(ctx) {
    const config = ctx.config;
    const variantId = readString(config, 'variantId', 'variant_id');
    if (!variantId) {
      return {
        status: 'failed',
        reason: 'missing_variant_id',
      };
    }
    const port = ctx.semanticPorts?.selectVariant;
    return invokeSemanticPort(
      ctx,
      'select_variant',
      port
        ? (context) =>
            port(
              {
                variantId,
                productId: readString(config, 'productId', 'product_id'),
                targetBlockId:
                  readString(config, 'targetBlockId', 'target_block_id') ??
                  ctx.intentEnvelope?.payload.context.blockId,
              },
              context
            )
        : undefined
    );
  },
};
